import styled from 'styled-components';

export const Table = styled('table')`
  background-color: #fefefe;
  border: 1px solid #ddd;
  border-collapse: collapse;
  border-radius: 3px;
  border-spacing: 0;
  margin-bottom: 20px;
  overflow: hidden;

  th,
  td {
    font-weight: normal;
    min-width: 100px;
    padding: 5px 20px;
    text-align: center;
  }

  tr :first-child {
    text-align: right;
  }

  thead th {
    background-color: #f7f7f7;
    font-weight: bold;
  }

  tbody {
    th,
    td {
      border-top: 1px solid #eee;
    }
  }
`;
